export default __webpack_public_path__ + "static/media/calconvert_l1.926aff23.png";